import { PlanData } from '@shared/models/paywall.model';
import { create } from 'zustand';

type PaywallDerived = {
  plan: PlanData['plan'];
  overLimit: boolean;
};

type PaywallStore = {
  open: boolean;
  planData?: PlanData;
  /** Derived from org + projects; set by PaywallDerivedSync so list items don't recompute */
  derived: PaywallDerived | null;
  openDialog: () => void;
  closeDialog: () => void;
  setPlanData: (data: PlanData | undefined) => void;
  setDerived: (derived: PaywallDerived) => void;
};

export const usePaywallStore = create<PaywallStore>()((set) => ({
  open: false,
  planData: undefined,
  derived: null,
  openDialog: () => set({ open: true }),
  closeDialog: () => set({ open: false }),
  setPlanData: (data) => set({ planData: data }),
  setDerived: (derived) => set({ derived }),
}));
